'use client';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import {paths} from 'src/routes/paths';
import {useTranslate} from 'src/locales';

import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {GetProfileOutput} from "@/types";

import {UserProfileCard} from './user-profile-card';
import {UserProfileStats} from './user-profile-stats';
import {UserRecipesList} from './user-recipes-list';
import {UserCommentsList} from './user-comments-list';

// ----------------------------------------------------------------------

type Props = {
  profile: GetProfileOutput;
};

// ----------------------------------------------------------------------

export function UserProfileView({profile}: Props) {
  const {t} = useTranslate();

  const userName = (profile.name || t('page.user.profile.user_name_placeholder')) as string;

  return (
    <Container>
      <CustomBreadcrumbs
        links={[
          {name: t('page.user.profile.breadcrumb.home') as string, href: paths.homepage},
          {name: t('page.user.profile.breadcrumb.user') as string, href: paths.user.profile(profile.pimcoreUserId)},
          {name: userName},
        ]}
        sx={{
          mb: {xs: 3, md: 5},
        }}
      />

      <Stack spacing={3}>
        {/* Karta profilu użytkownika */}
        <UserProfileCard profile={profile} userName={userName} />

        {/* Statystyki użytkownika */}
        <UserProfileStats profile={profile} />

        {/* Przepisy użytkownika */}
        <UserRecipesList
          userId={profile.pimcoreUserId!}
          totalRecipeCount={profile.recipeCount ?? 0}
        />

        {/* Ostatnie komentarze */}
        <UserCommentsList userId={profile.pimcoreUserId!} />
      </Stack>
    </Container>
  );
}


